import * as React from 'react'
import { FC } from 'react'
import { Field, Form, useFormikContext } from 'formik'
import { BaseTextField } from '@user/components/Formik'
import Box from '@mui/material/Box'
import { getPositionMenuItemStyles } from '@user/utils/usePositionMenuItemStyles'
import { IServiceTax } from '@user/store/serviceTax/typings'
import Grid from '@mui/material/Grid'
import MenuItem from '@mui/material/MenuItem'
import Button from '@mui/material/Button'
import { Theme, useTheme } from '@mui/material/styles'

const styles = {
  select: {
    width: '265px',
  },

  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '265px',
  },

  save: {
    marginLeft: (theme: Theme) => theme.spacing(1.2),
  },
}

interface Props {
  taxRates: IServiceTax[] | undefined
  onClose: () => void
}

interface FormValues {
  taxCode: string
}

export const TaxCodePopoverForm: FC<Props> = (props) => {
  const { taxRates, onClose } = props

  const { dirty, isSubmitting } = useFormikContext<FormValues>()

  const positionMenuItemStyles = getPositionMenuItemStyles(useTheme())
  return (
    <>
      {' '}
      <Form>
        <Grid>
          <Box mb={2} pr={2}>
            <Field
              name="taxCode"
              label="Tax Code"
              component={BaseTextField}
              sx={styles.select}
              required
              select
              data-test-id={`edit-tax-popover-tax-code-select`}
            >
              {taxRates?.map((b) => (
                <MenuItem
                  sx={positionMenuItemStyles.root}
                  key={b.id}
                  value={b.name}
                >
                  <span> {`${b.name} - ${b.description} (${b.rate})`} </span>
                </MenuItem>
              ))}
            </Field>
          </Box>

          <Box sx={styles.footer}>
            <Button
              variant="outlined"
              onClick={onClose}
              data-test-id={`edit-tax-popover-cancel-button`}
            >
              Cancel
            </Button>
            <Button
              sx={styles.save}
              disabled={!dirty || isSubmitting}
              color="primary"
              variant="contained"
              data-test-id={`edit-tax-popover-save-button`}
              type="submit"
            >
              Save
            </Button>
          </Box>
        </Grid>
      </Form>
    </>
  )
}

TaxCodePopoverForm.displayName = 'TaxCodePopoverForm'
